import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, faqJsonLd, serviceJsonLd, webPageJsonLd } from "@/lib/seo";
import { FAQS_SHOPIFY_DEV } from "@/lib/service-content/faqs/shopify-dev";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/shopify-experts";

export const Route = createFileRoute("/shopify-experts")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "en",
    title: "Shopify Development Agency: Themes, Apps & Replatforming · Shugert",
    description: "Senior Shopify engineering for custom themes, supported platform extensions, migrations, apps and integrations. Fixed scope with staging and release controls.",
    path: PATH,
    altPath: alternatePath(PATH, "es"),
    ogImage: "/og-development-v2.jpg",
    jsonLd: [
      breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Shopify Development", path: PATH }]),
      faqJsonLd(FAQS_SHOPIFY_DEV.en),
      serviceJsonLd({
        name: "Shopify Development",
        description: "Senior Shopify development for Online Store 2.0 themes, supported Plus capabilities, apps, integrations and controlled replatforming.",
        path: PATH,
        serviceType: "Shopify Development Agency",
        minPrice: 1500,
        unit: "PROJECT",
        deliverables: [
          "Architecture and ownership brief",
          "Written fixed-scope implementation plan",
          "Staged Shopify theme or platform development",
          "Representative QA and release controls",
          "Documentation and technical handoff",
        ],
        locale: "en",
      }),
      webPageJsonLd({
        name: "Shopify Development Agency",
        path: PATH,
        description: "Senior Shopify engineering with explicit architecture, staging, validation and handoff.",
        inLanguage: "en-US",
      }),
    ],
  }),
});
